import { api } from "@shared/api/client";
import type {
  IsoCertificateCode,
  IsoCertificateSlot,
  IsoCertificatesResponse,
} from "../types/certificados-iso";

const BASE_URL = "/certificaciones/certificados-iso";

export const isoCertificatesApi = {
  async list(): Promise<IsoCertificatesResponse> {
    const { data } = await api.get<IsoCertificatesResponse>(BASE_URL);
    return data;
  },

  async upload(codigo: IsoCertificateCode, file: File): Promise<IsoCertificateSlot> {
    const formData = new FormData();
    formData.append("documento", file);

    const { data } = await api.post<{ data: IsoCertificateSlot }>(
      `${BASE_URL}/${codigo}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    return data.data;
  },

  async preview(codigo: IsoCertificateCode): Promise<Blob> {
    const { data } = await api.get<Blob>(`${BASE_URL}/${codigo}/preview`, {
      responseType: "blob",
    });

    return data;
  },
};
